import script from "./PrimarySponsorContractCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimarySponsorContractCompleted.vue?vue&type=script&setup=true&lang=js"

import "./PrimarySponsorContractCompleted.vue?vue&type=style&index=0&id=400510fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400510fa"]])

export default __exports__